import React from "react";
import { Table } from "@chakra-ui/react";

const TableColumn = (props) => {
  const { columns = [] } = props;
  return (
    <Table.Header>
      <Table.Row>
        {columns.map((column) => (
          <Table.ColumnHeader
            key={column.key}
            fontWeight={600}
            fontSize="md"
            color="gray.400"
            textAlign={column.textAlign || "center"}
            width={column.width}
          >
            {column.label}
          </Table.ColumnHeader>
        ))}
      </Table.Row>
    </Table.Header>
  );
};

export default TableColumn;
